import { Component, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'client-switcher-dropdown',
  templateUrl: 'client-switcher-dropdown.component.html',
  styleUrls: ['client-switcher-dropdown.component.scss']
})
export class ClientSwitcherDropdownComponent implements OnChanges {
  @Input() sponsors: string[] = [];
  @Input() sponsorSelected = '';
  @Input() label = 'Sponsor';

  @Output() valueChange = new EventEmitter<string>();
  @Output() applyClicked = new EventEmitter<string>();

  open = false;

  highlightedIndex = 0;
  pendingValue: string | null = null;

  ngOnChanges(): void {
    if (!this.open) this.pendingValue = null;
    const total = this.allOptions.length;
    if (this.highlightedIndex >= total) this.highlightedIndex = total - 1;
    if (this.highlightedIndex < 0) this.highlightedIndex = 0;
  }

  get allOptions(): string[] {
    return ['All', ...(this.sponsors ?? [])];
  }

  toggle(): void {
    this.open = !this.open;
    if (this.open) {
      this.pendingValue = this.sponsorSelected;
      this.syncHighlightWith(this.pendingValue);
    } else {
      this.pendingValue = null;
    }
  }

  select(sponsor: string): void {
    this.pendingValue = sponsor;
    this.syncHighlightWith(sponsor);
  }

  get isDirty(): boolean {
    return (this.pendingValue ?? this.sponsorSelected) !== this.sponsorSelected;
  }

  apply(): void {
    if (!this.isDirty) return;
    const toApply = this.pendingValue as string;
    this.applyClicked.emit(toApply);
  }

  public close(): void {
    this.open = false;
    this.pendingValue = null;
  }

  @HostListener('document:click')
  closeOnOutsideClick(): void {
    this.open = false;
    this.pendingValue = null;
  }

  private syncHighlightWith(v: string): void {
    const idx = this.allOptions.indexOf(v);
    this.highlightedIndex = idx >= 0 ? idx : 0;
  }
}
